module.exports = __webpack_public_path__ + "img/le_pellerin-lazy.926a9bec.jpg";